module.exports = __webpack_public_path__ + "img/inventoryCheck.e3196663.svg";